angular.module('dpw.components')

    .directive('dpwAppProfileHistory', [function () {
        return {
            restrict: 'A',
            scope: {
                appProfileId: '<',
                organizationId: '<',
                isRevision: '<',
                isLastFromAdmin: '<?',
                isForcedExpanded: '<?'
            },
            bindToController: true,
            templateUrl: 'dpw-app-profile-history.html',
            controllerAs: 'ctrl',
            controller: ['$scope', '$q', 'paging', 'appProfileUtils', 'appProfileStatusHistoryService', 'developerService',
                function ($scope, $q, paging, appProfileUtils, appProfileStatusHistoryService, developerService) {
                    var self = this;

                    self.developers = {};

                    self.appendDevelopers = function (developers) {
                        if (Array.isArray(developers)) {
                            developers.forEach(function (developer) {
                                self.developers[developer.id] = developer;
                            });
                        }
                    };

                    self.loadAdditionalDevelopers = function (hitRecords) {
                        var additionalDeveloperIds = this.listAdditionalDeveloperIds(hitRecords);

                        additionalDeveloperIds.forEach(function (id) {
                            self.developers[id] = developerService.getDeveloper(id)
                                .then(function (developer) {
                                    self.developers[id] = developer;
                                })
                                .catch(function () {
                                    delete self.developers[id];
                                });
                        });
                    };

                    self.listAdditionalDeveloperIds = function (hitRecords) {
                        var additionalDevelopers = {};

                        if (Array.isArray(hitRecords)) {
                            hitRecords.forEach(function (record) {
                               var id = record.initiator.developerId;
                               var isAdditionalDeveloper = !self.developers[id];

                               if (id && isAdditionalDeveloper) {
                                   additionalDevelopers[id] = {};
                               }
                            });
                        }

                        return Object.keys(additionalDevelopers);
                    };

                    initDevelopers()
                        .then(loadStatusHistoryForPage);

                    var pagingHandler = paging.init($scope, loadStatusHistoryForPage, 'paging', self, 'ctrl');
                    pagingHandler.setPerPage(10);

                    self.getColorClassByProfileStatus = _.bind(appProfileUtils.getColorClassByProfileStatus, appProfileUtils);

                    self.toggleComment = function (item) {
                        item.expanded = !item.expanded;
                    };
                    self.getUserName = function (item) {
                        var adminId = _.get(item, 'initiator.adminId');
                        if (_.isString(adminId)) {
                            return RCDPW.isAdminSite ? [_.first(adminId.split('@')), '(Admin)'].join(' ') : 'Admin';
                        }

                        var developerId = _.get(item, 'initiator.developerId');
                        var developerName = getDeveloperName(developerId) || '';
                        
                        return developerName.trim() ||
                            RCDPW.Lang.MyAccount.OPERATOR_IS_DELETED_PLACEHOLDER;
                    };

                    self.isRecordForRevision = function (item) {
                        var targetType = _.get(item, 'target.type');
                        return targetType === appProfileStatusHistoryService.types.revision;
                    };

                    function getLastFromAdmin(history) {
                        history = history.filter(function (item) {
                            var isAdmin = _.get(item, 'initiator.role') === 'Admin';
                            return isAdmin;
                        });
                        var first = history[0];

                        return first ? [first] : [];
                    }

                    function getDeveloperName(developerId) {
                        var developer = self.developers[developerId];
                        var firstName = _.get(developer, 'firstName', '');
                        var lastName = _.get(developer, 'lastName', '');

                        return [firstName, lastName].join(' ');
                    }

                    function initDevelopers() {
                        return $q(function (resolve) {
                            appProfileUtils.fetchDevelopers({
                                organizationId: self.organizationId,
                                onSuccess: function (data) {
                                    self.appendDevelopers(data.developers);
                                    resolve();
                                }
                            });
                        });
                    }

                    function getStatus(item) {
                        var changedFields = _.get(item, 'details.changedFields', {});
                        var changedField = _.find(changedFields, {'fieldName': 'status'});
                        return changedField && changedField.newValue;
                    }

                    function loadStatusHistoryForPage() {
                        appProfileStatusHistoryService.fetch({
                            appProfileId: self.appProfileId,
                            params: {
                                resourceTypes: self.isRevision
                                    ? appProfileStatusHistoryService.types.revision
                                    : appProfileStatusHistoryService.types.origin
                            }
                        }, self.paging)
                            .then(function (data) {
                                var statusHistory = data.hitRecords || [];
                                statusHistory.forEach(function (item) {
                                    item.expanded = self.isForcedExpanded;
                                    item.status = getStatus(item);
                                });

                                self.loadAdditionalDevelopers(statusHistory);
                                self.history2Display = self.isLastFromAdmin ? getLastFromAdmin(statusHistory) : statusHistory;
                                self.noHistoryRecord = self.history2Display.length === 0;
                                pagingHandler.reset(data);
                            });
                    }
                }]
        };
    }])

    .directive('dpwAppProfileHistorySeeAll', [function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-app-profile-history-see-all.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                var config = $scope.seeAllConfig || {};

                this.close = config.close || function () {
                };
                this.appProfileId = config.appProfileId;
                this.organizationId = config.organizationId;
                this.isRevision = config.isRevision;
            }]
        };
    }]);
